import { DefaultTheme } from "styled-components";
import { bearish as bearishAlert } from "../components/Alert/theme";
import { bearish as bearishCard } from "../components/Card/theme";
import { bearish as bearishRadio } from "../components/Radio/theme";
import { bearish as bearishToggle } from "../components/Toggle/theme";
import { bearish as bearishNav } from "../widgets/Menu/theme";
import { bearish as bearishModal } from "../widgets/Modal/theme";
import { bearish as bearishTooltip } from "../components/Tooltip/theme";
import base from "./base";
import { BearishColors } from "./colors";

const bearishTheme: DefaultTheme = {
  ...base,
  isDark: false,
  isBearish: true,
  isBullish: false,
  alert: bearishAlert,
  colors: BearishColors,
  card: bearishCard,
  toggle: bearishToggle,
  nav: bearishNav,
  modal: bearishModal,
  radio:bearishRadio,
  tooltip: bearishTooltip,
};

export default bearishTheme;
